import { render, staticRenderFns } from "./BindResult.vue?vue&type=template&id=5e630434&scoped=true"
import script from "./BindResult.vue?vue&type=script&lang=js"
export * from "./BindResult.vue?vue&type=script&lang=js"
import style0 from "./BindResult.vue?vue&type=style&index=0&id=5e630434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e630434",
  null
  
)

export default component.exports